import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import RadioEssayList from "./RadioEssayList";
import RadioEssayDetail from "./RadioEssayDetail";
import "./App.css";

function Home() {
  return (
    <main className='landing'>
      <img
        src={process.env.PUBLIC_URL + "/hero.svg"}
        alt='A nighttime scene with a radio tower under a crescent moon'
        className='hero-image'
      />
      <h1 className='site-title'>Anu Dudley</h1>
      <p className='site-tagline'>
        <a
          href='https://archives.weru.org/category/earthwise/'
          className='tagline-link'
        >
          Earthwise
        </a>
      </p>
      <Link to='/essays' className='essays-link'>
        Radio Essays
      </Link>
    </main>
  );
}

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/essays' element={<RadioEssayList />} />
        <Route path='/essays/:id' element={<RadioEssayDetail />} />
      </Routes>
    </div>
  );
}

export default App;
